import { ajax } from '../../../services/helper'
class ApiService {

    getMenusData = (city_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/menus/list?city_id="+city_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

   
    getMenuById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/menus/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getMenuGroupsDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/menus/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    


    addMenu = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/menus/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    editMenu = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/menus/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Menus/services/apiservices.js